export const chartOptions = {
  maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: false,
        text: "text",
      },
    },
    scales: {
      y: {
        beginAtZero: true
    }
  }
}

